module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ye-948f27c439684b56bb9df2416b59b6f7.svg";